// extracted by mini-css-extract-plugin
export default {"Git":"Calender_Git__tBQKb","heading":"Calender_heading__ftF-c","heading2":"Calender_heading2__xiNvw"};